import { render, staticRenderFns } from "./EventRaceAdvanceSettings.vue?vue&type=template&id=8b64b6da&"
import script from "./EventRaceAdvanceSettings.vue?vue&type=script&lang=js&"
export * from "./EventRaceAdvanceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports